import { render, staticRenderFns } from "./TenantsSlimList.vue?vue&type=template&id=5c581ae6&"
import script from "./TenantsSlimList.vue?vue&type=script&lang=js&"
export * from "./TenantsSlimList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports